import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于yy漫画网 - 韩漫免费在线阅读平台',
    description: 'yy漫画网致力于为中文用户提供免费韩国漫画在线阅读服务，支持下拉式阅读体验，涵盖丰富题材。',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'yy漫画网',
    url: 'https://yymanhua.com',
    description: '韩漫免费在线阅读平台 - 提供丰富的韩国漫画资源，支持下拉式阅读',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@yymanhua.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <main className="min-h-screen bg-background-50 pt-16">
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />
      </div>

      <section className="py-10 md:py-16 bg-background-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
              关于<span className="text-primary-600">yy漫画网</span>
            </h1>
            <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              yy漫画网是一个专注于韩国漫画的免费在线阅读平台，致力于为中文用户提供最优质的韩漫阅读体验
            </p>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 bg-background-100">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-6">
                品牌<span className="text-primary-600">介绍</span>
              </h2>
              <div className="space-y-4">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  yy漫画网成立于2024年，由一群热爱韩国漫画的年轻人创立。我们深知韩漫爱好者在寻找优质中文翻译资源时的困难，因此决定打造一个完全免费、体验优秀的韩漫在线阅读平台。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们的团队分布在中国、韩国和东南亚各地，每天与韩国多家漫画平台和翻译团队紧密合作，确保第一时间为用户带来最新、最热门的韩漫内容。目前平台已收录超过<strong>1000部</strong>优质韩国漫画，涵盖恋爱、动作、奇幻、悬疑等多个热门分类。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  yy漫画网独创的<strong>下拉式阅读模式</strong>，专为移动端用户设计，让阅读韩漫像刷社交媒体一样流畅自然。无论是在通勤路上、午休时间还是睡前片刻，您都可以随时随地打开yy漫画网，享受沉浸式的韩漫阅读体验。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们始终坚持<strong>完全免费</strong>的原则，不设付费墙，不限阅读次数。yy漫画网相信，优秀的漫画作品应该被更多人看到和喜爱。同时，我们也积极与韩国原创漫画平台合作，通过正版授权的方式支持创作者，推动韩漫文化在中国的健康发展。
                </p>
              </div>
            </div>
            <div className="flex-1">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20reading%20space%20with%20a%20digital%20tablet%20displaying%20colorful%20Korean%20manhwa%20illustrations%2C%20warm%20ambient%20lighting%2C%20bookshelves%20in%20background%2C%20comfortable%20armchair%2C%20minimalist%20aesthetic%2C%20soft%20beige%20and%20cream%20tones%2C%20artistic%20atmosphere&width=800&height=600&seq=about-brand-yy-01&orientation=landscape"
                alt="yy漫画网品牌形象"
                title="yy漫画网 - 韩漫免费在线阅读平台"
                className="w-full rounded-lg object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 bg-background-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
              用户<span className="text-accent-600">口碑</span>
            </h2>
            <p className="text-sm text-foreground-500">听听我们的用户怎么说</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                name: '小雨',
                role: '大学生',
                text: 'yy漫画网真的是我用过最好的韩漫阅读平台！下拉式阅读太方便了，在地铁上刷漫画比刷短视频还上瘾。关键是全部免费，良心网站！',
                rating: 5,
              },
              {
                name: '阿强',
                role: '上班族',
                text: '每天午休时间都会打开yy漫画网追更，更新速度很快，基本上韩国那边一出新章节就能看到。分类也很全，各种类型的韩漫都有。',
                rating: 5,
              },
              {
                name: '小美',
                role: '自由职业者',
                text: '作为一个韩漫重度爱好者，yy漫画网的资源库太丰富了！从经典老番到最新热门都有，而且不需要注册就能看，太方便了。强烈推荐！',
                rating: 5,
              },
              {
                name: '大飞',
                role: '设计师',
                text: '界面设计简洁干净，没有乱七八糟的广告弹窗，阅读体验非常好。下拉式阅读的流畅度也比其他平台好很多，用起来很舒服。',
                rating: 5,
              },
              {
                name: '琳琳',
                role: '高中生',
                text: '同学推荐给我的，现在每天都在用！最喜欢恋爱题材的韩漫，画风都超级好看。追了好多部连载中的，每天都有新期待。',
                rating: 4,
              },
              {
                name: '老张',
                role: 'IT工程师',
                text: '技术层面做得很好，加载速度快，图片清晰度高。支持各种设备无缝切换，在公司电脑上看到一半，回家手机继续看，进度自动同步。',
                rating: 5,
              },
            ].map((review, index) => (
              <div
                key={index}
                className="p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-sm ${i < review.rating ? 'text-accent-500' : 'text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">&ldquo;{review.text}&rdquo;</p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-sm font-bold">
                    {review.name[0]}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{review.name}</div>
                    <div className="text-xs text-foreground-500">{review.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="faq" className="py-10 md:py-16 bg-background-100">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
              常见<span className="text-secondary-600">问题</span>
            </h2>
            <p className="text-sm text-foreground-500">关于yy漫画网的常见问题解答</p>
          </div>
          <div className="max-w-3xl mx-auto grid gap-4">
            {[
              { q: 'yy漫画网需要付费吗？', a: '不需要！yy漫画网上的所有韩漫资源完全免费，无需任何付费即可畅快阅读。' },
              { q: '支持哪些设备？', a: '支持手机、平板、电脑等所有主流设备，自动适配屏幕尺寸。' },
              { q: '如何联系客服？', a: '您可以通过邮箱 contact@yymanhua.com 联系我们，我们会在24小时内回复。' },
              { q: '漫画多久更新一次？', a: '热门连载漫画通常每周更新1-2次，确保您能及时看到最新内容。' },
              { q: '可以下载漫画吗？', a: '目前yy漫画网仅支持在线下拉式阅读，暂不支持下载功能。' },
            ].map((faq, index) => (
              <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                  <h4 className="text-sm font-semibold text-foreground-900 pr-4">{faq.q}</h4>
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 bg-background-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
              联系<span className="text-primary-600">我们</span>
            </h2>
            <p className="text-sm text-foreground-500">如果您有任何问题或建议，欢迎随时联系我们</p>
          </div>
          <div className="max-w-3xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-500">contact@yymanhua.com</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                <p className="text-sm text-foreground-500">yy漫画网</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500 mb-3">
                  <i className="ri-weibo-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">官方微博</h3>
                <p className="text-sm text-foreground-500">@yy漫画网</p>
              </div>
            </div>

            <div className="text-center">
              <p className="text-sm text-foreground-600 mb-6">
                我们非常重视每一位用户的意见和建议，您的反馈将帮助我们不断改进平台体验
              </p>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line"></i>
                返回首页开始阅读
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}